export const Routes = {
  BOOTSTRAP: '/',
  TEST: '/test',
  // Onboarding
  LANGUAGE_SELECTION: '/onboarding/languageSelection',
  ENTER_NAME: '/onboarding/name',
  SELECT_GENDER: '/onboarding/gender',
  WHATS_YOUR_AGE: '/onboarding/age',
  ENTER_PHONE_NUMBER: '/onboarding/phoneNumber',
  ENTER_OTP: '/onboarding/otp',
  SELECT_PROFILE_PICTURE: '/onboarding/profilePicture',
  SELECT_CITY: '/onboarding/city',
  SELECT_CURRENT_LOCATION: '/onboarding/currentLocation',
  SELECT_HOME_LOCATION: '/onboarding/homeLocation',
  SELECT_QUALIFICATION: '/onboarding/qualification',
  ARE_YOU_MARRIED: '/onboarding/maritialStatus',
  JOINING_DURATION: '/onboarding/joiningDuration',
  WORK_EXPERIENCE: '/onboarding/workExperience',
  WORK_EXPERIENCE_FORM: '/onboarding/workExperienceForm',
  MULTIPLE_JOBS: '/onboarding/multipleJobs',
  MULTIPLE_SKILLS: '/onboarding/multipleSkills',
  SELECT_JOB_PREFERENCE: '/onboarding/jobPreference',
  EXPECTED_SALARY: '/onboarding/expectedSalary',
  CONNECT_MITRAS: '/onboarding/connectMitras',
  PROFILE_SUCCESS: '/onboarding/profileSuccess',
  UPLOAD_DOCUMENTS: '/onboarding/upload',
  PROFILE: '/profile/info',
  HOME_PAGE: '/homePage/info',
  JD: '/jd/info',
  APPLY_JOB: '/jd/applyJob',
  APPLY_JOB_BIKE: '/jd/applyJobBike',
  APPLY_JOB_DL: '/jd/applyJobDL',
  MITRA_PROFILE: '/mitraProfile/info',
  APPLY_JOB_DOC: '/jd/applyJobDoc',
  BIKE_NOT_AVAILABLE: '/jd/bikeRequired',
  DL_NOT_AVAILABLE: '/jd/DLRequired',
  UPLOAD_RC: '/jd/uploadRc',
  IMAGE_UPLOAD: '/jd/imageUpload',
  APPLICATION_SUCCESS: '/jd/applicationSuccess',
  USER_DETAILS: '/jd/userDetails',
  EDIT_DOCUMENT_SAFE: '/profile/editDocument',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_USE: '/terms-of-use',
  REFERRAL: '/referral',
  KNOWLEDGE_CENTRE: '/knowledgeCentre',
  ONE_CODE: '/one-code',
  MITRA_SHOTS: '/mitra-bonus',
  DYNAMIC_MITRA_PAGE: '/page/:id',
  NON_PAYROLL_LANDING_PAGE: '/non-payroll',
  MY_JOBS_STATUS: '/status',
  MY_JOB_STATUS_DETAILS: '/status/details',
  MY_JOB_LISTING_For_REJECTED_CANDIDATES: '/jobs',
  My_JOBS_STATUS: '/status',
  My_JOB_STATUS_DETAILS: '/status/details',

  WELCOME_PRAYER: '/prayer/welcome',
  SELECT_FAITH: '/prayer/select-faith',
  SELECT_GOD: '/prayer/select-god',
  PRAYER_OFFERING: '/prayer/prayer-offering',
  SELECT_EARNINGS: '/savingsCalculator/earnings',
  SELECT_SAVINGS: '/savingsCalculator/savings',
  SAVINGS_AMOUNT: '/savingsCalculator/savings-amount',
  CAPTCHA: '/captcha',
  MITRA_TELECALLER: '/mitra-telecaller',
  JOB_LISTINGS: '/job-listings',
  SELECT_CITY_WISE_JOBS: '/jobs/select-city',
  JOB_DESCRIPTION: '/job-description',
  MARKETPLACE_WELCOME_SCREEN: '/jobs/welcome',
  APPLICATION_STATUS: '/application-status',
  ADDITIONAL_INFO: '/additional-info',
  VALIDATE_OTP: '/validate-otp',
  CONTENT_VIDEOS: '/content/videos',
  ADDITIONAL_DETAILS_FOR_BEST_JOB: '/additional-details',
  SUCCESSFULLY_APPLIED: '/successfully-applied',
  FINDING_JOBS: '/finding-jobs',
  NOTIFICATIONS: '/notifications'
};
export const stacks = {
  BOOTSTRAP: 'bootstrap',
  HOME: 'home',
  ON_BOARDING: 'onBoarding',
  PROFILE: 'profiles',
  PRIVACY_POLICY: 'privacy_policy',
  TERMS_OF_USE: 'terms-of-use',
  REFERRAL: 'referral',
  KNOWLEDGE_CENTRE: 'knowledge_centre',
  MITRA_SHOTS: 'mitra_bonus',
  DYNAMIC_MITRA_PAGE: 'page',
  NON_PAYROLL: 'non-payroll',
  MY_JOB_LISTING_For_REJECTED_CANDIDATES: 'jobs',
  My_JOBS_STATUS: 'status',
  PRAYER: 'prayer',
  SAVINGS_CALCULATOR: 'savingsCalculator',
  CAPTCHA: 'captcha',
  ONE_CODE: 'one-code',
  MITRA_TELECALLER: '/mitra-telecaller',
  JOB_LISTINGS: '/job-listings',
  SELECT_CITY_WISE_JOBS: '/jobs/select-city',
  JOB_DESCRIPTION: '/job-description',
  APPLICATION_STATUS: '/application-status',
  ADDITIONAL_INFO: '/additional-info',
  VALIDATE_OTP: '/validate-otp',
  CONTENT_VIDEOS: '/content/videos',
  ADDITIONAL_DETAILS_FOR_BEST_JOB: '/additional-details',
  SUCCESSFULLY_APPLIED: '/successfully-applied',
  FINDING_JOBS: '/finding-job',
  NOTIFICATIONS: '/notifications'
};
export const routeMap = {
  [Routes.BOOTSTRAP]: { pathname: Routes.BOOTSTRAP, stack: stacks.BOOTSTRAP },
  [Routes.TEST]: { pathname: Routes.TEST, stack: stacks.BOOTSTRAP },
  /**
   * OnBoarding
   */
  [Routes.LANGUAGE_SELECTION]: {
    pathname: Routes.LANGUAGE_SELECTION,
    stack: stacks.ON_BOARDING,
    order: 10,
  },
  [Routes.ENTER_NAME]: {
    pathname: Routes.ENTER_NAME,
    stack: stacks.ON_BOARDING,
    order: 20,
  },
  [Routes.UPLOAD_DOCUMENTS]: {
    pathname: Routes.UPLOAD_DOCUMENTS,
    stack: stacks.ON_BOARDING,
  },
  [Routes.ENTER_OTP]: {
    pathname: Routes.ENTER_OTP,
    stack: stacks.ON_BOARDING,
    order: 198,
  },
  [Routes.ENTER_PHONE_NUMBER]: {
    pathname: Routes.ENTER_PHONE_NUMBER,
    stack: stacks.ON_BOARDING,
    order: 196,
  },
  [Routes.SELECT_GENDER]: {
    pathname: Routes.SELECT_GENDER,
    stack: stacks.ON_BOARDING,
    order: 30,
  },
  [Routes.SELECT_PROFILE_PICTURE]: {
    pathname: Routes.SELECT_PROFILE_PICTURE,
    stack: stacks.ON_BOARDING,
    order: 70,
  },
  [Routes.SELECT_CITY]: {
    pathname: Routes.SELECT_CITY,
    stack: stacks.ON_BOARDING,
    order: 80,
  },
  [Routes.SELECT_CURRENT_LOCATION]: {
    pathname: Routes.SELECT_CURRENT_LOCATION,
    stack: stacks.ON_BOARDING,
    order: 90,
  },
  [Routes.SELECT_QUALIFICATION]: {
    pathname: Routes.SELECT_QUALIFICATION,
    stack: stacks.ON_BOARDING,
    order: 110,
  },
  [Routes.SELECT_JOB_PREFERENCE]: {
    pathname: Routes.SELECT_JOB_PREFERENCE,
    stack: stacks.ON_BOARDING,
    order: 190,
  },
  [Routes.EXPECTED_SALARY]: {
    pathname: Routes.EXPECTED_SALARY,
    stack: stacks.ON_BOARDING,
    order: 195,
  },
  [Routes.WORK_EXPERIENCE]: {
    pathname: Routes.WORK_EXPERIENCE,
    stack: stacks.ON_BOARDING,
    order: 150,
  },
  [Routes.CONNECT_MITRAS]: {
    pathname: Routes.CONNECT_MITRAS,
    stack: stacks.ON_BOARDING,
    order: 200,
  },
  [Routes.PROFILE_SUCCESS]: {
    pathname: Routes.PROFILE_SUCCESS,
    stack: stacks.ON_BOARDING,
    order: 210,
  },
  [Routes.MULTIPLE_JOBS]: {
    pathname: Routes.MULTIPLE_JOBS,
    stack: stacks.ON_BOARDING,
    order: 170,
  },
  [Routes.MULTIPLE_SKILLS]: {
    pathname: Routes.MULTIPLE_SKILLS,
    stack: stacks.ON_BOARDING,
    order: 180,
  },
  [Routes.WORK_EXPERIENCE_FORM]: {
    pathname: Routes.WORK_EXPERIENCE_FORM,
    stack: stacks.ON_BOARDING,
    order: 160,
  },
  [Routes.WHATS_YOUR_AGE]: {
    pathname: Routes.WHATS_YOUR_AGE,
    stack: stacks.ON_BOARDING,
    order: 40,
  },
  [Routes.ARE_YOU_MARRIED]: {
    pathname: Routes.ARE_YOU_MARRIED,
    stack: stacks.ON_BOARDING,
    order: 120,
  },
  [Routes.JOINING_DURATION]: {
    pathname: Routes.JOINING_DURATION,
    stack: stacks.ON_BOARDING,
    order: 130,
  },
  [Routes.SELECT_HOME_LOCATION]: {
    pathname: Routes.SELECT_HOME_LOCATION,
    stack: stacks.ON_BOARDING,
    order: 100,
  },
  [Routes.JD]: {
    pathname: Routes.JD,
    stack: stacks.HOME,
    order: 500,
  },
  [Routes.SALARY_SELECTION]: {
    pathname: Routes.SALARY_SELECTION,
    stack: stacks.ON_BOARDING,
    order: 220,
  },
  /**
   * Home Stack
   */
  [Routes.HOME_PAGE]: {
    pathname: Routes.HOME_PAGE,
    stack: stacks.HOME,
    order: 300,
  },
  [Routes.JD]: {
    pathname: Routes.JD,
    stack: stacks.HOME,
    order: 500,
  },
  [Routes.APPLY_JOB]: {
    pathname: Routes.APPLY_JOB,
    stack: stacks.HOME,
    order: 510,
  },
  [Routes.APPLY_JOB_BIKE]: {
    pathname: Routes.APPLY_JOB_BIKE,
    stack: stacks.HOME,
    order: 520,
  },
  [Routes.BIKE_NOT_AVAILABLE]: {
    pathname: Routes.BIKE_NOT_AVAILABLE,
    stack: stacks.HOME,
    order: 530,
  },
  [Routes.APPLY_JOB_DL]: {
    pathname: Routes.APPLY_JOB_DL,
    stack: stacks.HOME,
    order: 540,
  },
  [Routes.DL_NOT_AVAILABLE]: {
    pathname: Routes.DL_NOT_AVAILABLE,
    stack: stacks.HOME,
    order: 550,
  },
  [Routes.USER_DETAILS]: {
    pathname: Routes.USER_DETAILS,
    stack: stacks.HOME,
    order: 560,
  },
  [Routes.APPLICATION_SUCCESS]: {
    pathname: Routes.APPLICATION_SUCCESS,
    stack: stacks.HOME,
    order: 570,
  },
  [Routes.UPLOAD_RC]: {
    pathname: Routes.UPLOAD_RC,
    stack: stacks.HOME,
    order: 260,
  },
  [Routes.IMAGE_UPLOAD]: {
    pathname: Routes.IMAGE_UPLOAD,
    order: 620,
  },
  [Routes.MITRA_PROFILE]: {
    pathname: Routes.MITRA_PROFILE,
    stack: stacks.MITRA_PROFILE,
    order: 570, // need to change the order
  },
  [Routes.APPLY_JOB_DOC]: {
    pathname: Routes.APPLY_JOB_DOC,
    stack: stacks.HOME,
    order: 580, // need to change the order
  },
  /**
   * Profile
   */
  [Routes.PROFILE]: { pathname: Routes.PROFILE, stack: stacks.PROFILE, order: 600 },
  [Routes.EDIT_DOCUMENT_SAFE]: {
    pathname: Routes.EDIT_DOCUMENT_SAFE,
    stack: stacks.PROFILE,
    order: 610,
  },
  /**
   * Privacy-policy
   */
  [Routes.PRIVACY_POLICY]: {
    pathname: Routes.PRIVACY_POLICY,
    stack: stacks.PRIVACY_POLICY,
    order: 100,
  },
  /**
   * Terms-of-Use
   */
  [Routes.TERMS_OF_USE]: {
    pathname: Routes.TERMS_OF_USE,
    stack: stacks.TERMS_OF_USE,
    order: 100,
  },
  [Routes.REFERRAL]: {
    pathname: Routes.REFERRAL,
    stack: stacks.REFERRAL,
    order: 720,
  },
  [Routes.MY_JOBS_STATUS]: {
    pathname: Routes.MY_JOBS_STATUS,
    stack: stacks.MY_JOBS_STATUS,
    order: 730,
  },
  [Routes.MY_JOB_STATUS_DETAILS]: {
    pathname: Routes.MY_JOB_STATUS_DETAILS,
    stack: stacks.MY_JOBS_STATUS,
    order: 730,
  },
  [Routes.NON_PAYROLL_LANDING_PAGE]: {
    pathname: Routes.NON_PAYROLL_LANDING_PAGE,
    stack: stacks.NON_PAYROLL,
    order: 730,
  },
  [Routes.MY_JOB_LISTING_For_REJECTED_CANDIDATES]: {
    pathname: Routes.MY_JOB_LISTING_For_REJECTED_CANDIDATES,
    stack: stacks.MY_JOB_LISTING_For_REJECTED_CANDIDATES,
    order: 740,
  },

  /**
   * Knowledge-center
   */
  [Routes.KNOWLEDGE_CENTRE]: {
    pathname: Routes.KNOWLEDGE_CENTRE,
    stack: stacks.KNOWLEDGE_CENTRE,
    order: 750,
  },
  /**
   * One-code
   */
  [Routes.ONE_CODE]: {
    pathname: Routes.ONE_CODE,
    stack: stacks.ONE_CODE,
    order: 750,
  },

  /**
   * Mitra-shots
   */
  [Routes.MITRA_SHOTS]: {
    pathname: Routes.MITRA_SHOTS,
    stack: stacks.MITRA_SHOTS,
    order: 760,
  },

  /**
   * Dynamic-Mitra-Pages
   */
  [Routes.DYNAMIC_MITRA_PAGE]: {
    pathname: Routes.DYNAMIC_MITRA_PAGE,
    stack: stacks.DYNAMIC_MITRA_PAGE,
    order: 760,
  },
  /**
   * Prayer
   */
  [Routes.WELCOME_PRAYER]: {
    pathname: Routes.WELCOME_PRAYER,
    stack: stacks.PRAYER,
    order: 800,
  },
  [Routes.SELECT_FAITH]: {
    pathname: Routes.SELECT_FAITH,
    stack: stacks.PRAYER,
    order: 810,
  },
  [Routes.SELECT_GOD]: {
    pathname: Routes.SELECT_GOD,
    stack: stacks.PRAYER,
    order: 820,
  },
  [Routes.PRAYER_OFFERING]: {
    pathname: Routes.PRAYER_OFFERING,
    stack: stacks.PRAYER,
    order: 830,
  },

  /**
   * SAVINGS_CALCULATOR
   */
  [Routes.SELECT_EARNINGS]: {
    pathname: Routes.SELECT_EARNINGS,
    stack: stacks.SAVINGS_CALCULATOR,
    order: 840,
  },
  [Routes.SELECT_SAVINGS]: {
    pathname: Routes.SELECT_SAVINGS,
    stack: stacks.SAVINGS_CALCULATOR,
    order: 850,
  },
  [Routes.SAVINGS_AMOUNT]: {
    pathname: Routes.SAVINGS_AMOUNT,
    stack: stacks.SAVINGS_CALCULATOR,
    order: 860,
  },

  /**
   * Captcha
   */
  [Routes.CAPTCHA]: {
    pathname: Routes.CAPTCHA,
    stack: stacks.CAPTCHA,
    order: 870,
  },

  [Routes.MITRA_TELECALLER]: {
    pathname: Routes.MITRA_TELECALLER,
    stack: stacks.MITRA_TELECALLER,
    order: 880,
  },
  [Routes.JOB_LISTINGS]: {
    pathname: Routes.JOB_LISTINGS,
    stack: stacks.JOB_LISTINGS,
    order: 900,
  },
  [Routes.SELECT_CITY_WISE_JOBS]: {
    pathname: Routes.SELECT_CITY_WISE_JOBS,
    stack: stacks.SELECT_CITY_WISE_JOBS,
    order: 910,
  },
  [Routes.JOB_DESCRIPTION]: {
    pathname: Routes.JOB_DESCRIPTION,
    stack: stacks.JOB_DESCRIPTION,
    order: 890,
  },
  [Routes.MARKETPLACE_WELCOME_SCREEN]: {
    pathname: Routes.MARKETPLACE_WELCOME_SCREEN,
    stack: stacks.MARKETPLACE_WELCOME_SCREEN,
    order: 920,
  },
  [Routes.APPLICATION_STATUS]: {
    pathname: Routes.APPLICATION_STATUS,
    stack: stacks.APPLICATION_STATUS,
    order: 930,
  },
  [Routes.CONTENT_VIDEOS]: {
    pathname: Routes.CONTENT_VIDEOS,
    stack: stacks.CONTENT_VIDEOS,
    order: 940,
  },
  [Routes.ADDITIONAL_INFO]: {
    pathname: Routes.ADDITIONAL_INFO,
    stack: stacks.ADDITIONAL_INFO,
    order: 940,
  },
  [Routes.VALIDATE_OTP]: {
    pathname: Routes.VALIDATE_OTP,
    stack: stacks.VALIDATE_OTP,
    order: 950,
  },
  [Routes.ADDITIONAL_DETAILS_FOR_BEST_JOB]: {
    pathname: Routes.ADDITIONAL_DETAILS_FOR_BEST_JOB,
    stack: stacks.ADDITIONAL_DETAILS_FOR_BEST_JOB,
    order: 960,
  },
  [Routes.SUCCESSFULLY_APPLIED]: {
    pathname: Routes.SUCCESSFULLY_APPLIED,
    stack: stacks.SUCCESSFULLY_APPLIED,
    order: 970,
  },
  [Routes.FINDING_JOBS]: {
    pathname: Routes.FINDING_JOBS,
    stack: stacks.FINDING_JOBS,
    order: 980,
  },
  [Routes.NOTIFICATIONS]: {
    pathname: Routes.NOTIFICATIONS,
    stack: stacks.NOTIFICATIONS,
    order: 990,
  },
};
